import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './Contact.css';

const Contact = () => {
  // State to hold contact information
  const [contactInfo] = useState({ linkedin: 'https://www.linkedin.com/in/stellacraig/', github: 'https://github.com/stella-craig', email: 'stellarstellacraig@gmail.com' });
  
  // State to hold form data
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  
  // State to track if the form has been submitted
  const [submitted, setSubmitted] = useState(false);

  // Handle input field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // Send email using EmailJS
    emailjs.send('service_3w9dyj8', 'template_thajauf', formData, 'IeawJGEm7enzCafiK')
      .then((response) => {
        console.log('Email sent successfully:', response.status, response.text);
        setSubmitted(true);
      })
      .catch((error) => {
        console.error('Failed to send email:', error);
      });
  };

  return (
    <section id="contact" className="contact-section">
      <h2 className="contact-heading">Contact Me</h2>
      <p className="form-heading">Connect with me online:</p>
      <div className="contact-links">
        <a href={contactInfo.linkedin} target="_blank" rel="noopener noreferrer" className="button">
          <span className="icon">🔗</span> LinkedIn
        </a>
        <a href={contactInfo.github} target="_blank" rel="noopener noreferrer" className="button">
          <span className="icon">🐙</span> GitHub
        </a>
        <a href={`mailto:${contactInfo.email}`} className="button">
          <span className="icon">✉️</span> Email
        </a>
      </div>
      <h3 className="form-heading">Or send me a message:</h3>
      {submitted ? (
        // Display thank-you message if form is submitted
        <p className="success-message">Thank you for your message! I'll get back to you soon.</p>
      ) : (
        // Display form if not submitted
        <form onSubmit={handleSubmit} className="contact-form">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            className="input"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            className="input"
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            className="textarea"
            required
          />
          <button type="submit" className="submit-button">Submit</button>
        </form>
      )}
    </section>
  );
};

export default Contact;
